// KL guide: how to become a personal trainer in Malaysia (trainer funnel).
const content = {
    slug: 'become-a-personal-trainer-malaysia',
    title: 'How to Become a Personal Trainer in Malaysia | Certification Guide',
    description: 'How to become a personal trainer in Malaysia: certification options, first aid, building experience, working for a gym or freelance, and finding clients in KL.',
    eyebrow: 'Malaysia · Trainer careers',
    h1: 'How to Become a Personal Trainer in Malaysia',
    lead: 'Personal training in Malaysia has no single mandatory licence, which makes the right certification and a strong reputation all the more important. Here is a practical path from qualifying to filling your schedule in KL.',
    datePublished: '2026-10-03',
    image: 'personal-trainer/personal-trainers.jpg',
    imageAlt: 'Personal trainer coaching a client',
    summary: {
        title: 'The path in brief',
        items: [
            'Earn a recognised personal training certification.',
            'Get first aid and CPR certified.',
            'Build experience in a gym or under a senior trainer.',
            'Specialise, then grow a client base - in a gym, freelance or both.',
        ],
    },
    sections: [
        {
            title: 'Choose a certification',
            paragraphs: [
                'Many Malaysian trainers hold internationally recognised certifications such as NASM, ACE or ISSA, studied online or through local education partners. Local options include certificates from fitness academies and the national sports coaching certification pathway. Choose one that covers anatomy, programme design, nutrition basics and practical coaching - and that gyms you want to work at recognise.',
            ],
        },
        {
            title: 'Gym or freelance',
            cards: [
                { title: 'Gym-based', body: 'A steady stream of members, often a base salary plus commission. Sales targets are common.' },
                { title: 'Freelance', body: 'Higher rate per session and your own schedule, training clients in condo gyms, homes and parks. You find your own clients and handle admin.' },
            ],
        },
        {
            title: 'Getting clients in KL',
            items: [
                'Specialise - weight loss, women\'s fitness, pre and postnatal, seniors - and say so clearly.',
                'Condo communities: one happy client often leads to neighbours.',
                'Collect testimonials and before-and-after results (with permission).',
                'Platforms like StringsSG bring you matched clients and handle scheduling and payment.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Do I need a licence to be a personal trainer in Malaysia?',
            answer: 'There is no single mandatory licence, but gyms and clients expect a recognised certification plus first aid and CPR.',
        },
        {
            question: 'How much do personal trainers earn in KL?',
            answer: 'It varies widely with experience and client numbers. Freelance trainers with a full schedule usually earn more per hour than gym-employed trainers, but carry their own costs.',
        },
    ],
    cta: {
        title: 'Join our founding trainer team in KL',
        body: 'Certified trainers: we bring matched clients, you focus on coaching.',
        href: '/service-provider-signup',
        label: 'Apply as a trainer',
    },
}

export default content
